import Reveal from "@/components/Reveal";

const NOTE_IMAGE = "/photos/couple-arch.webp";

export default function FamilyNote() {
    return (
        <section id="story" data-testid="family-note-section" className="mx-auto max-w-5xl px-6 py-20 sm:py-28">
            <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-12">
                <div className="md:col-span-7">
                    <Reveal>
                        <p className="eyebrow">01 · Our beginning</p>
                        <h2 className="font-display mt-4 text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl" style={{ color: "var(--ink)" }}>
                            Two hearts, <span className="italic" style={{ color: "var(--wine)" }}>one beautiful beginning</span>
                        </h2>
                        <p className="mt-6 text-base leading-relaxed sm:text-lg" style={{ color: "var(--muted)" }}>
                            With joy in our hearts, we invite you to celebrate Vijju and Dileep as they begin their
                            forever, two souls on one beautiful journey.
                        </p>
                        <p className="mt-4 text-base leading-relaxed sm:text-lg" style={{ color: "var(--muted)" }}>
                            Your presence and your blessings will make their celebration truly complete.
                        </p>
                        <p className="font-display mt-8 text-xl italic" style={{ color: "var(--wine)" }}>
                            With love, the Hambad and Panwar families
                        </p>
                    </Reveal>
                </div>
                <div className="md:col-span-5">
                    <Reveal delay={0.15}>
                        <div className="arch-frame float-slow mx-auto max-w-xs sm:max-w-sm">
                            <img
                                src={NOTE_IMAGE}
                                alt="Vijay Laxmi and Dileep framed by a painted haveli arch at dusk"
                                data-testid="family-note-image"
                                className="h-[380px] w-full object-cover sm:h-[460px]"
                            />
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
